module.exports = __webpack_public_path__ + "img/check.b0e6167c.svg";